import { render } from "./AddDivisionView.vue?vue&type=template&id=b94b56e8&scoped=true"
import script from "./AddDivisionView.vue?vue&type=script&lang=js"
export * from "./AddDivisionView.vue?vue&type=script&lang=js"

import "./AddDivisionView.vue?vue&type=style&index=0&id=b94b56e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94b56e8"]])

export default __exports__